import { forwardRef } from "react";
import type { ReactNode } from "react";
import { cn } from "@ui/lib/utils";

interface MessagesListProps {
  anchor?: "top" | "bottom";
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export const MessagesList = forwardRef<HTMLDivElement, MessagesListProps>(
  ({ anchor = "top", children, className, contentClassName }, ref) => {
    return (
      <div ref={ref} className={cn("tw-relative tw-size-full tw-min-h-0 tw-overflow-hidden", className)}>
        <div
          className={cn(
            "tw-absolute tw-inset-x-0 tw-bottom-0 tw-flex tw-min-h-full tw-w-full tw-flex-col tw-gap-2",
            anchor === "top" ? "tw-justify-start" : "tw-justify-end",
            contentClassName,
          )}
        >
          {children}
        </div>
      </div>
    );
  },
);

MessagesList.displayName = "MessagesList";
